import { render } from "./ShipTrackChatHelpDialog.vue?vue&type=template&id=49fbc48f&scoped=true"
import script from "./ShipTrackChatHelpDialog.vue?vue&type=script&lang=js"
export * from "./ShipTrackChatHelpDialog.vue?vue&type=script&lang=js"

import "./ShipTrackChatHelpDialog.vue?vue&type=style&index=0&id=49fbc48f&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-49fbc48f"]])

export default __exports__